import { render, staticRenderFns } from "./Masker2.vue?vue&type=template&id=012d1138&scoped=true"
import script from "./Masker2.vue?vue&type=script&lang=js"
export * from "./Masker2.vue?vue&type=script&lang=js"
import style0 from "./Masker2.vue?vue&type=style&index=0&id=012d1138&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012d1138",
  null
  
)

export default component.exports